export const PRODUCT_FORM_MAP = {
    "HiPhos 10,000 GT": 10000,
    "HiPhos 20,000 GT": 20000,
    "HiPhos 20,000 L": 20000,
    "HiPhos 50,000 M": 50000,
    "HiPhos 65,000 L": 65000
};

export const DOSE_FYT_MIN = {
    "Broiler": 500,
    "Swine": 500,
    "Layer": 300,
    "Aqua": 500
};

export const DOSE_FYT_MAX = {
    "Broiler": 3000,
    "Swine": 3000,
    "Layer": 1800,
    "Aqua": 3000
};

export const PRODUCT_DEFAULT_PRICES = {
    "HiPhos 10,000 GT": 10,
    "HiPhos 20,000 GT": 20,
    "HiPhos 20,000 L": 20,
    "HiPhos 65,000 L": 65,
    "HiPhos 50,000 M": 50
};

export const PHOSPHATE_DEFAULT_PRICES = {
    "Aqua": {
        "PP": 0.550,
        "MSP": 0.540,
        "DCP": 0.425,
        "MCP": 0.510
    },
    "Broiler": {
        "TCP": 0.550,
        "MDCP": 0.540,
        "DCP": 0.425,
        "MCP": 0.510
    },
    "Layer": {
        "TCP": 0.550,
        "MDCP": 0.540,
        "DCP": 0.425,
        "MCP": 0.510
    },
    "Swine": {
        "TCP": 0.430,
        "MDCP": 0.490,
        "DCP": 0.425,
        "MCP": 0.510
    }
};

export const PHOSPHATE_DEFAULTS = {
    "Aqua": {
        "PP": { price: 0.550, total: 22.5, available: 90, fullName: 'Potassium Phosphate'},
        "MSP": {price: 0.540, total: 22.5, available: 89, fullName: 'MonoSodium Phosphate'},
        "DCP": {price: 0.425, total: 18, available: 82, fullName: 'Dicalcium Phosphate'},
        "MCP": { price: 0.510, total: 22.5, available: 76, fullName: 'Monocalcium Phosphate'}
    },
    "Broiler": {
        "TCP": { price: 0.430, total: 18, available: 65, fullName: 'Tricalcium Phosphate', digFactor: 65},
        "MDCP": { price: 0.490, total: 21, available: 81, fullName: 'Monodicalcium Phosphate', digFactor: 81},
        "DCP": {price: 0.425, total: 18, available: 79, fullName: 'Dicalcium Phosphate', digFactor: 79},
        "MCP": { price: 0.510, total: 22.5, available: 83, fullName: 'Monocalcium Phosphate', digFactor: 83}
    },
    "Layer": {
        "TCP": { price: 0.430, total: 18, available: 65, fullName: 'Tricalcium Phosphate', digFactor: 65 },
        "MDCP": { price: 0.490, total: 21, available: 81, fullName: 'Monodicalcium Phosphate', digFactor: 81 },
        "DCP": { price: 0.425, total: 18, available: 79, fullName: 'Dicalcium Phosphate', digFactor: 79 },
        "MCP": { price: 0.510, total: 22.5, available: 83, fullName: 'Monocalcium Phosphate', digFactor: 83 }
    },
    "Swine": {
        "TCP": { price: 0.430, total: 18, available: 60, fullName: 'Tricalcium Phosphate'},
        "MDCP": { price: 0.490, total: 21, available: 80, fullName: 'Monodicalcium Phosphate'},
        "DCP": { price: 0.425, total: 18, available: 72, fullName: 'Dicalcium Phosphate'},
        "MCP": { price: 0.510, total: 22.5, available: 89, fullName: 'Monocalcium Phosphate'}
    }
};